import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CvExportConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CvExportService } from './api/cvExport.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CvExportApiModule {
    public static forRoot(configurationFactory: () => CvExportConfiguration): ModuleWithProviders<CvExportApiModule> {
        return {
            ngModule: CvExportApiModule,
            providers: [ { provide: CvExportConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CvExportApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CvExportApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
